import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { PositionSchema } from '../../shared/position.schema';
/**
 * POST /api/v2/process/:id/draft/steps — request
 *
 * `position` seeds the new step's entry in the draft-scoped `ProcessLayout`
 * doc. The step itself doesn't carry position — layout lives exclusively in
 * `ProcessLayout` — but passing it here avoids a follow-up layout round-trip
 * when the user right-clicks to add at a specific point.
 *
 * `laneKey` is a creation-time placement hint pointing at an existing
 * swimlane (e.g. `dept-<id>`, `team-<id>`, `system-<id>`, `external-<id>`).
 * The new step renders in that lane while its assignee is still empty; once
 * the user assigns the step, the server clears `laneKey` and the real
 * assignee takes over.
 *
 * `attachStartEventId` names this draft's start event: the new step is
 * created attached to it (the first step) in the same request, so the add is
 * one undo entry.
 *
 * The response envelope carries the new step in `nodes` and its
 * `stableStepId` in `createdNodeIds`.
 */ export const AddDraftStepRequestSchema = z.object({
    position: PositionSchema,
    laneKey: z.string().optional(),
    attachStartEventId: ObjectIdSchema.optional()
});

//# sourceMappingURL=add-draft-step.schema.js.map